"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var card_1 = __importStar(require("../card"));
var createErrorHandler = function (errorNotifier) { return function (err) {
    switch (err) {
        case card_1.Errors.CompendaNotResponding:
            errorNotifier('Compenda lijkt niet te reageren');
            break;
        case card_1.Errors.EntityNotFound:
            errorNotifier('Kan entiteit niet vinden');
            break;
        default:
            errorNotifier('Er is een onbekende fout opgetreden');
            break;
    }
}; };
function default_1(Vue, options) {
    if (options === undefined)
        options = {};
    if (options.globalOpenHandler === undefined)
        options.globalOpenHandler = function () { };
    if (options.globalCloseHandler === undefined)
        options.globalCloseHandler = function () { };
    if (options.globalNotFoundHandler === undefined)
        options.globalNotFoundHandler = function () { };
    card_1.CreateGlobalHandlers(options.globalOpenHandler, options.globalCloseHandler, options.globalNotFoundHandler);
    var errorHandler;
    if (options.errorNotifier === undefined) {
        errorHandler = function () { };
    }
    else {
        errorHandler = createErrorHandler(options.errorNotifier);
    }
    var compendaFunctions = {
        getArticle: function (id) { return card_1.default(card_1.EntityType.Article, id); },
        getOrder: function (id) { return card_1.default(card_1.EntityType.Order, id); },
        getProject: function (id) { return card_1.default(card_1.EntityType.Project, id); },
        getRelation: function (id) { return card_1.default(card_1.EntityType.Relation, id); },
        getTask: function (id) { return card_1.default(card_1.EntityType.Task, id); },
        errorHandler: errorHandler,
    };
    Vue.prototype.$compenda = compendaFunctions;
}
exports.default = default_1;
